import {
  ScrollView,
  Text,
  TextInput,
  TouchableOpacity,
  View,
  StyleSheet,
  KeyboardAvoidingView
} from 'react-native'
import { Ionicons, FontAwesome, AntDesign } from '@expo/vector-icons'

// styles
import {
  colorPalette,
  fontPalette,
  globalStyles
} from '../../static/styles/global'

// components
import Card from '../../components/shared/card/Card'
import CardSeparator from '../../components/shared/card/CardSeparator'
import TabSwitch from '../../components/shared/form/TabSwitch'
import { useState } from 'react'
import ScheduleTimePicker from '../../components/schedule/ScheduleTimePicker'
import CustomButton from '../../components/shared/button/Button'
import MyScrollView from '../../components/shared/navigator/MyScrollView'

const DailyAvailabilityScreen = ({ navigation }): JSX.Element => {
  const [availableToggle, setAvailableToggle] = useState(true)
  const [timePickerVisible, setTimePickerVisible] = useState(false)

  const handleAvailableTimeToggle = () => {
    setAvailableToggle(!availableToggle)
    setTimePickerVisible(!timePickerVisible)
  }

  return (
    <MyScrollView>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.horizontalPadGap]}>
          <View
            style={[
              globalStyles.hDirection,
              globalStyles.vCenterItems,
              globalStyles.hBetweenItems,
              globalStyles.mb3
            ]}
          >
            <TouchableOpacity
              style={[globalStyles.hDirection, globalStyles.vCenterItems]}
              onPress={() => {
                navigation.goBack()
              }}
            >
              <View style={[globalStyles.relativePosition, globalStyles.ln6]}>
                <Ionicons
                  name="chevron-back"
                  size={24}
                  color={colorPalette.white}
                />
              </View>
              <Text
                style={[
                  globalStyles.text,
                  globalStyles.fwBold,
                  globalStyles.fs20,
                  globalStyles.whiteTextColor,
                  globalStyles.ml0
                ]}
              >
                Daily Availability
              </Text>
            </TouchableOpacity>
            <View></View>
          </View>

          <View>
            <Text style={[globalStyles.text, globalStyles.whiteTextColor]}>
              Enter hours for which you are available to be scheduled for a
              shift.
            </Text>
          </View>
        </View>
      </View>
      <View style={[globalStyles.containerOverlap]}>
        <Card>
          <View
            style={[
              globalStyles.hDirection,
              globalStyles.vCenterItems,
              globalStyles.hBetweenItems
            ]}
          >
            <Text
              style={[
                globalStyles.text,
                globalStyles.fwBold,
                globalStyles.fs18,
                globalStyles.blackTextColor
              ]}
            >
              Monday
            </Text>
          </View>
          <CardSeparator />
          <TabSwitch />
          <CardSeparator light={true} narrowBottom={true} />
          <View
            style={[
              globalStyles.hDirection,
              globalStyles.hBetweenItems,
              globalStyles.vCenterItems
            ]}
          >
            <Text style={[globalStyles.text, globalStyles.blackTextColor]}>
              Available All Day
            </Text>
            <TouchableOpacity onPress={handleAvailableTimeToggle}>
              <FontAwesome
                name={availableToggle ? 'toggle-on' : 'toggle-off'}
                size={30}
                color={colorPalette.secondary}
              />
            </TouchableOpacity>
          </View>
          <View style={[globalStyles.mt4]}>
            <Text style={[globalStyles.text]}>Add Note</Text>
            <TextInput
              multiline
              numberOfLines={4}
              placeholder=""
              style={[
                globalStyles.input,
                globalStyles.inputLight,
                globalStyles.textarea
              ]}
              blurOnSubmit={false}
            />
          </View>
          <CardSeparator light={true} narrowTop={true} />
          <View
            style={[
              globalStyles.hDirection,
              globalStyles.hBetweenItems,
              globalStyles.vCenterItems
            ]}
          >
            <Text style={[globalStyles.text, globalStyles.blackTextColor]}>
              Start Time / End Time
            </Text>
            <Text style={[globalStyles.text, globalStyles.blackTextColor]}>
              10:00 AM – 2:00 PM
            </Text>
          </View>
          <CardSeparator light={true} />
          <View
            style={[
              globalStyles.hDirection,
              globalStyles.hBetweenItems,
              globalStyles.vCenterItems
            ]}
          >
            <Text
              style={[
                globalStyles.text,
                globalStyles.fwSemiBold,
                globalStyles.blackTextColor
              ]}
            >
              Add Second Shift
            </Text>
            <TouchableOpacity onPress={() => {}}>
              <AntDesign
                name="pluscircleo"
                size={24}
                color={colorPalette.secondary}
              />
            </TouchableOpacity>
          </View>
        </Card>
      </View>
      <View style={[globalStyles.horizontalPadGap, globalStyles.mb8]}>
        <CustomButton
          text="Add Availability"
          onPress={() => {
            navigation.navigate('ConfirmScheduleAvailability')
          }}
        />
      </View>
      <ScheduleTimePicker
        title={'Select time'}
        visible={timePickerVisible}
        setVisible={setTimePickerVisible}
      />
    </MyScrollView>
  )
}

export default DailyAvailabilityScreen
